import React from "react";
import { gatherInitialValues, submitHandler } from "../../service/FormService";
import { Party } from "../enums/Party";
import { FormikValues } from "formik";
import { FormikStepper } from "../navigation/FormikStepper";
import { FormikStep } from "../navigation/FormikStep";
import { BenefitType, findRelationshipsFor } from "../enums/BenefitType";
import BeneficiaryStart from "../page/beneficiary/BeneficiaryStart";
import AboutBeneficiary from "../page/beneficiary/AboutBeneficiary";
import { BeneficiaryPages } from "../enums/BeneficiaryPages";
import BeneficiaryFinished from "../page/beneficiary/BeneficiaryFinished";
import BeneficiarySummary from "../page/beneficiary/BeneficiarySummary";
import ContactBeneficiary from "../page/beneficiary/ContactBeneficiary";
import { validateDocumentContent, validateDocumentsTotalSize } from "../../form/Validators";
import BeneficiaryRelationship from "../page/beneficiary/BeneficiaryRelationship";
import BeneficiaryClaimType from "../page/beneficiary/BeneficiaryClaimType";
import BeneficiaryFinancial from "../page/beneficiary/BeneficiaryFinancial";
import { object } from "yup";
import BeneficiaryDocument from "../page/beneficiary/BeneficiaryDocument";
import { useParams } from "react-router-dom";
import { FormValues } from "./FormValues";
import EmpathyServices from "../page/beneficiary/EmpathyServices";

const Beneficiary = () => {
    const params = useParams();
    const coverage = params.coverage as BenefitType;
    const claimId = params.claimId;

    const initialValues = gatherInitialValues(claimId, coverage, Party.BENEFICIARY) as FormikValues;

    return <FormikStepper initialValues={initialValues}
                          onSubmit={submitHandler}>
        <FormikStep label={BeneficiaryPages.START}>
            <BeneficiaryStart/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.BENEFICIARY_INFO} hideStep={(initialValues) => initialValues.beneficiaryFirstName === undefined}>
            <AboutBeneficiary/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.CONTACT_INFO}
                    hideStep={(initialValues) => initialValues.beneficiaryPhoneNumber === undefined}>
            <ContactBeneficiary/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.RELATIONSHIP} hideStep={(_, values) => findRelationshipsFor(values as FormValues).length < 2}>
            <BeneficiaryRelationship/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.CLAIM_TYPE} hideStep={(initialValues) => initialValues.mannerOfDeath === undefined}>
            <BeneficiaryClaimType/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.FINANCIAL}
                    hideStep={(initialValues) => initialValues.taxIdentificationNumber === undefined}>
            <BeneficiaryFinancial/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.DOCUMENT}
                    hideStep={(initialValues) => initialValues.documents === undefined}
                    validationSchema={object({
                        documents: validateDocumentContent(),
                    })} validate={(values) => validateDocumentsTotalSize(values)}>
            <BeneficiaryDocument/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.EMPATHY}
                    hideStep={(initialValues) => initialValues.optOutOfEmpathy === undefined}>
            <EmpathyServices/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.SUMMARY}>
            <BeneficiarySummary/>
        </FormikStep>
        <FormikStep label={BeneficiaryPages.FINISH}>
            <BeneficiaryFinished/>
        </FormikStep>
    </FormikStepper>;
}

export default Beneficiary;